import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

import Couimg from "../assets/img/oneimg1.png";
import Couimgg from "../assets/img/oneimg2.png";
import Image1 from "../assets/img/courtest1.png";
import Image2 from "../assets/img/courtest4.png";
import Image3 from "../assets/img/courtest3.png";
import Image4 from "../assets/img/courtest2.png";

import Video1 from '../assets/video/video1.mp4';
import Video2 from '../assets/video/video2.mp4';
import Video3 from '../assets/video/video3.mp4';
import Video4 from '../assets/video/video4.mp4';
import Gmailicon from '../assets/img/gmail.png';
import Phoneicon from '../assets/img/phone.png';
import Playbtn from '../assets/img/play.png';

import onebg from '../assets/img/one/oneweek.jpg';
import onebg1 from '../assets/img/one/one_week.png';
import Icon1 from '../assets/img/one/icon1.png';
import Icon2 from '../assets/img/one/icon2.png';
import Icon3 from '../assets/img/one/icon3.png';
import Icon4 from '../assets/img/one/icon4.png';

import Icon5 from '../assets/img/one/icon5.jpg';
import Icon6 from '../assets/img/one/icon6.jpg';
import Icon7 from '../assets/img/one/icon7.jpg';
import Icon8 from '../assets/img/one/icon8.jpg';
import Icon51 from '../assets/img/icon51.png';
import Icon61 from '../assets/img/icon61.png';
import Icon71 from '../assets/img/icon71.png';
import Icon81 from '../assets/img/icon81.png';
import Icon9 from '../assets/img/one/icon9.jpg';

import imgcha from '../assets/img/one/img3.png';
import imgcha1 from '../assets/img/one/img21.png';

import SeoHelmet from "../components/SeoHelmet";
import iconstrt from "../assets/img/iconstartt.png";
import CommonModal from "../components/CommonModal";
import RazorpayModal from "../components/RazorpayModal";

const Oneweekdays = () => {
  useEffect(() => {
       document.body.classList.add('oneweek-page');
   
       return () => {
         document.body.classList.remove('oneweek-page');
       };
     }, []);

const [activeVideo, setActiveVideo] = useState(null);
const [formData, setFormData] = useState({
  name: "",
  email: "",
  phone: ""
});

    
      const handleOpenModal = (videoSrc) => {
        setActiveVideo(videoSrc); // Set the active video source
      };
    
      const handleCloseModal = () => {
        setActiveVideo(null); // Clear the active video source
      };

     


      const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData((prevData) => ({ ...prevData, [name]: value }));
      };

       
    
 

  

  useEffect(() => {
       
    if (window.Swiper) {
      
     

      const swiper = new window.Swiper(".coursesslide", {
        loop: true,
        slidesPerView: 1,
        navigation: {
          nextEl: ".testi-button-next",
          prevEl: ".testi-button-prev",
        },
        breakpoints: {
          768: {
            slidesPerView: 3, 
            spaceBetween: 30,
            navigation: {
              nextEl: ".testi-button-next",
              prevEl: ".testi-button-prev",
            },
          },
          // You can add more breakpoints if needed
        },
      
      });
       
     
    }
  }, []); 


  return (
    <>
 <SeoHelmet />
<CommonModal id="staticBackdrop" />

    <section className="oneofone_section fivedys one-weekss" style={{ backgroundImage: `url(${onebg})` }}>
      <div class="container">
        <div className="contentone_outer">
          <div className="title_one">
            <h4>1 Week to a New You</h4>
            <h2>Personality Transform Course</h2>
          </div>
          <div className="skillbox">
              <ul>
                <li><img src={Icon1}></img><spna>Professional<br></br> Photoshoot of New You</spna></li>
                <li><img src={Icon2}></img><spna>Simple Language,<br></br> Easy to Follow</spna></li>
                <li><img src={Icon3}></img><spna>Public Speaking<br></br> Confidence</spna></li>
                <li><img src={Icon4}></img><spna>Strong and Calm<br></br> Mindset</spna></li>
              </ul>
          </div>
          <div className="skillbox_content">
              <h3>At the End of the Course You Will Have </h3>
              <p>A transformed personality that opens doors and takes you places, with a clear personal style, stronger confidence, and polished body language. You’ll walk, speak, and present yourself with ease, making an impact in every professional, social, and personal space you enter.</p>
          </div>
          <div className="onedetails">
              <div className="details_col">
                  <h2>Details:</h2>
                   <ul>
                      <li><h4>Duration</h4><spna>07 Days</spna></li>
                      <li><h4>location</h4><spna>Live Online Sessions</spna></li>
                      <li><h4>fees</h4><spna> ₹100,000/-</spna></li>
                    </ul>
              </div>
              <div className="details_col-con">
                <div className="days_box">
                  <h3><p>Day<span>1</span></p>Knowing Yourself Better</h3>
                  <div className="daytext">
                     <p><b>.</b> Your Strengths: Learn what you are good at</p>
                     <p><b>.</b> Confidence Blocks: Find what lowers your confidence</p>
                     <p><b>.</b> New Start: Build a better, stronger you</p>
                  </div>
                </div>
                <div className="days_box">
                  <h3><p>Day<span>2</span></p>First Impression</h3>
                  <div className="daytext">
                     <p><b>.</b> Confident Entry: Learn how to enter confidently</p>
                     <p><b>.</b> Stand Out: Be noticed in a natural way</p>
                     <p><b>.</b> Good Energy: Make people feel positive around you</p>
                  </div>
                </div>
                <div className="days_box">
                  <h3><p>Day<span>3</span></p>Personal Style</h3>
                  <div className="daytext">
                     <p><b>.</b> Right Clothes: Know what clothes suit you</p>
                     <p><b>.</b> Best Colours: Choose colours that look good</p>
                     <p><b>.</b> Daily Dressing: Dress well every day</p>
                  </div>
                </div>
                <div className="days_box">
                  <h3><p>Day<span>4</span></p>Body Language</h3>
                  <div className="daytext">
                     <p><b>.</b> Good Posture: Stand and sit with confidence</p>
                     <p><b>.</b> Better Walk: Learn to walk confidently</p>
                     <p><b>.</b> Eye Contact: Use eyes and gestures properly</p>
                  </div>
                </div>
                <div className="days_box">
                  <h3><p>Day<span>5</span></p>Grooming & Makeup</h3>
                  <div className="daytext">
                     <p><b>.</b> Easy Makeup: Simple makeup for daily use</p>
                     <p><b>.</b> Skin Care: Learn basic skin care routine</p>
                     <p><b>.</b> Neat Look: Always look clean and presentable	</p>
                  </div>
                </div>
                <div className="days_box">
                  <h3><p>Day<span>6</span></p>Practice Day</h3>
                  <div className="daytext">
                     <p><b>.</b> Practice Skills: Use what you have learned</p>
                     <p><b>.</b> Personal Help: Get direct guidance from Bhavana</p>
                     <p><b>.</b> Real Situations: Practice daily life situations	</p>
                  </div>
                </div>
                <div className="days_box">
                  <h3><p>Day<span>7</span></p>Celebration Day</h3>
                  <div className="daytext">
                     <p><b>.</b> Photo Shoot: Professional photos of new you</p>
                     <p><b>.</b> Proud Moment: Feel confident and happy</p>
                     <p><b>.</b> Certificate: Receive course completion certificate</p>
                  </div>
                </div>
              </div>
          </div>
        </div>
      </div>
    </section>

    <section className="whycho">
      <div className="onembr_row">
        <div className="imageonerr">
          <img className="imageonerr1" src={imgcha} ></img>
           <img className="imageonerr2" src={imgcha1} ></img>
        </div>
        <div className="contentoner oneweek_contentoner">
          <h2>Why <br></br>Choose This Course</h2>
          <ul>
            <li><img className="num" src={Icon5} ></img><img className="num1" src={Icon51} ></img><span>In-Person Personality Guidance: Work directly with Bhavana to enhance your unique traits and personal presence.</span></li>
            <li><img className="num" src={Icon6} ></img><img className="num1" src={Icon61} ></img><span>Transformative Personality Skills: Build confidence, communication, and style that reflect your strongest self.</span></li>
            <li><img className="num" src={Icon7} ></img><img className="num1" src={Icon71} ></img><span>Fast-Tracked Personal Growth: Achieve in days what typically takes years of trial and error.</span></li>
            <li><img className="num" src={Icon8} ></img><img className="num1" src={Icon81} ></img><span>Mindset & Personality Boost: Strengthen self-belief, poise, and the ability to command any space naturally.</span></li>
            
          </ul>
         <div className="btngroup">
                  <a
                  href="/two-week-transformation"
                  className="terrs_btn" data-bs-toggle="modal" data-bs-target="#staticBackdrop"
                >
                  <img src={iconstrt} alt="" />
                  Get In Touch
                </a>
                <a
  href="#"
  data-bs-toggle="modal"
  data-bs-target="#offlineModal"
  className="terrs_btn"
>
  <img src={iconstrt} alt="" />
  ENROLL NOW
</a>
              </div>
        </div>
      </div>
    </section>

   
   <RazorpayModal
  id="offlineModal"
  title="Pay for Offline Course"
  courseType="offline"
/>


    </>
  );
};

export default Oneweekdays;
